import React from "react";
import LandmarkLogo from "../LandmarkLogo";
import { Headshot } from "./shared";

// Vertical 50/50: photo + cream block on the left, forest panel with stacked type on the right.
export default function Split({ data, headshot }) {
  const parts = (data.name || "New Hire").trim().split(/\s+/);
  const first = parts[0];
  const rest = parts.slice(1).join(" ");
  return (
    <div className="wp-canvas wp-t-split">
      <div className="wp-t-split__left">
        <Headshot headshot={headshot} className="wp-t-split__photo" />
        <div className="wp-t-split__left-foot">
          {data.note && <span className="wp-t-split__note">{data.note}</span>}
          <span className="wp-t-split__url">landmarkventures.com</span>
        </div>
      </div>

      <div className="wp-t-split__panel">
        <header className="wp-t-split__top">
          <LandmarkLogo width={210} />
        </header>

        <div className="wp-t-split__copy">
          <p className="wp-t-split__eyebrow">{data.tagline || "Welcome to the team"}</p>
          <h1>
            <span>{first}</span>
            {rest && <span>{rest}</span>}
          </h1>
          <span className="wp-t-split__rule" />
          {data.role && <p className="wp-t-split__role">{data.role}</p>}
          {data.team && <p className="wp-t-split__team">{data.team}</p>}
        </div>

        <footer className="wp-t-split__footer">
          <span>Success at every stage</span>
        </footer>
      </div>
    </div>
  );
}
